var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 13.2,
    viewBox: "0 0 12 13.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#6f6f6f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M8,1A3.6,3.6,0,0,0,4.4,4.6C4.4,7.172,8,11.2,8,11.2s3.6-4.028,3.6-6.6A3.6,3.6,0,0,0,8,1ZM8,2.2a2.4,2.4,0,0,1,2.4,2.4c0,1.206-1.249,3.216-2.4,4.716C6.846,7.819,5.6,5.81,5.6,4.6A2.4,2.4,0,0,1,8,2.2ZM8,3.4A1.2,1.2,0,1,0,9.2,4.6,1.2,1.2,0,0,0,8,3.4ZM5.288,9.661C3.339,10.057,2,10.865,2,11.8c0,1.325,2.686,2.4,6,2.4s6-1.075,6-2.4c0-.935-1.339-1.742-3.288-2.139-.271.4-.537.76-.782,1.078A5.266,5.266,0,0,1,12.77,11.8C12.461,12.191,10.818,13,8,13v0H8c-2.816,0-4.459-.807-4.768-1.2A5.251,5.251,0,0,1,6.07,10.739C5.825,10.421,5.559,10.057,5.288,9.661Z",
    transform: "translate(-2 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.d452b7bc7efcf3f754705a8fa884fcbc.svg";
export { ForwardRef as ReactComponent };